/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Hide/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import TysiaVisibility from 'DesignSystem/Svgs/TysiaVisibility/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Hide({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Details/Ssn/Hide",
  isInvalid,
  onChange
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let isMedia = useIsMedia()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let profilePatientPersonSsnValueData = fromData.useDataFormat({ viewPath,
context: 'profile_patient',
path: 'person.ssn',
format: fromHelpers.socialSecurityNumberHide,
})
let profilePatientPersonSsnIsValidData = fromData.useDataIsValid({ viewPath,
context: 'profile_patient',
path: 'person.ssn',
validate: fromValidate.social_security_number,
})
let profilePatientPersonSsnChangeData = fromData.useDataChange({ viewPath,
context: 'profile_patient',
path: 'person.ssn',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={dtSpaceS}
 type="text"
 size={isMedia.mobile ? "small" : "medium"}
 disabled={true}
 data="profile_patient.person.ssn"
 validate="/Data/validate.js social_security_number"
 invalid={!profilePatientPersonSsnIsValidData}
 format="helpers.js socialSecurityNumberHide"
 value={profilePatientPersonSsnValueData}
 onChange={profilePatientPersonSsnChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="SSN"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 tabIndex={7}
/>
<button
  data-testid="Hide.Horizontal"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Show'))}
 {...isHoveredBind}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaVisibility
  viewPath={`${viewPath}/TysiaVisibility`}
 width={18}
 height={18}
 stroke="rgb(0,150,89)"
/>
</button>
</React.Fragment>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}